module.exports = __webpack_public_path__ + "img/16.ac7303aa.jpg";